import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Table } from "orion";
import { connect } from "react-redux";
import Severity from "../sharedComponent/severity";
import { setTableOrder, loadMoreRows } from "../../actionCreators/alertsListActionCreators";
import { AttributeValue, cellRendererWithToolTip } from "../sharedComponent/detailsItem";
import { useAlerts } from "../../contexts/alertsContext";
import { useDruvaAlerts } from "../../contexts/DruvaAlertsContext";

var cellRenderer = function cellRenderer(_ref) {
  var cellData = _ref.cellData;
  return /*#__PURE__*/React.createElement(AttributeValue, {
    details: cellData
  });
};

var severityCellRenderer = function severityCellRenderer(severity) {
  var cellData = severity.cellData;
  return /*#__PURE__*/React.createElement(Severity, {
    severity: cellData
  });
};

var columns = [{
  dataKey: "id"
}, {
  dataKey: "severityType",
  label: "Severity Type",
  width: 0,
  flexGrow: 4,
  cellRenderer: severityCellRenderer
}, {
  dataKey: "alertTypeName",
  label: "Alert Type",
  width: 0,
  flexGrow: 4,
  sortable: true,
  cellRenderer: cellRendererWithToolTip
}, {
  dataKey: "source",
  label: "Source",
  width: 0,
  flexGrow: 4,
  cellRenderer: cellRenderer
}, {
  dataKey: "detail",
  label: "Detail",
  width: 0,
  flexGrow: 4,
  cellRenderer: cellRenderer
}, {
  dataKey: "occurrenceTime",
  label: "Generated On",
  width: 0,
  flexGrow: 4,
  sortable: true,
  cellRenderer: cellRendererWithToolTip
}];

var AlertsTable = function AlertsTable(props) {
  var onAlertsSelect = props.onAlertsSelect,
      setTableOrder = props.setTableOrder,
      loadMoreRows = props.loadMoreRows;

  var _useDruvaAlerts = useDruvaAlerts(),
      _useDruvaAlerts$apiCo = _useDruvaAlerts.apiConfig,
      alertsApiPath = _useDruvaAlerts$apiCo.alertsApiPath,
      accessTokenApiPath = _useDruvaAlerts$apiCo.accessTokenApiPath,
      alertsApiBaseUrl = _useDruvaAlerts$apiCo.alertsApiBaseUrl;

  var _useAlerts = useAlerts(),
      alerts = _useAlerts.alerts,
      sortBy = _useAlerts.sortBy,
      sortOrder = _useAlerts.sortOrder,
      nextPageToken = _useAlerts.nextPageToken,
      loadingMore = _useAlerts.loadingMore,
      isFirstLoad = _useAlerts.isFirstLoad;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRows = _useState2[0],
      onRowSelect = _useState2[1];

  var dataList = alerts || [];
  var onSortCallback = useCallback(function (column, direction) {
    setTableOrder(column, direction);
  }, []);
  var loadMoreRowsCallback = useCallback(function () {
    if (nextPageToken) {
      loadMoreRows(nextPageToken, alertsApiBaseUrl, alertsApiPath, accessTokenApiPath);
    }

    return null;
  }, [nextPageToken]);
  var getRowStyleCallback = useCallback(function (_ref2) {
    var data = _ref2.data;
    var viewed = data.viewed;
    return {
      background: viewed ? "" : "#FFFCEF"
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "oui-pt-3 oui-pb-4 h-100-40px"
  }, /*#__PURE__*/React.createElement(Table, {
    columnsDef: columns,
    dataList: dataList,
    multiSelect: false,
    sortBy: sortBy,
    sortDirection: sortOrder,
    sort: onSortCallback,
    selectedRows: [selectedRows],
    onRowClick: function onRowClick(event) {
      onRowSelect(event.rowData.id);
      onAlertsSelect(event.rowData);
    },
    enableInfiniteLoading: true,
    loadMoreRows: loadMoreRowsCallback,
    isLoading: loadingMore,
    noDataMessage: isFirstLoad ? "" : "No Data Found",
    getRowStyle: getRowStyleCallback
  }));
};

cellRenderer.propTypes = {
  cellData: PropTypes.object.isRequired
};
AlertsTable.propTypes = {
  onAlertsSelect: PropTypes.func.isRequired
};
var mapDispatchToProps = {
  setTableOrder: setTableOrder,
  loadMoreRows: loadMoreRows
};
export default connect(null, mapDispatchToProps)(AlertsTable);